import _defineProperty from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from "react";
var debugOptions = {
  debugReducer: true,
  debugContext: true,
  disable: false,
  disableAutoMode: false
};
export var ContextDevTool = function ContextDevTool(_ref) {
  var id = _ref.id,
    Context = _ref.context,
    displayName = _ref.displayName;
  if (debugOptions.disable) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Context.Consumer, null, function (values) {
    if (typeof window !== 'undefined' && window._REACT_CONTEXT_DEVTOOL) {
      window._REACT_CONTEXT_DEVTOOL({
        id: id,
        displayName: displayName,
        values: values
      });
    }
    return null;
  });
};
export var debugContextDevtool = function debugContextDevtool(container, options) {
  debugOptions = _objectSpread(_objectSpread({}, debugOptions), options);
  if (debugOptions.disable || debugOptions.disableAutoMode || typeof window === 'undefined' || !debugOptions.debugReducer && !debugOptions.debugContext) {
    return false;
  }
  var hook = window.__REACT_CONTEXT_DEVTOOL_GLOBAL_HOOK;
  if (debugOptions.debugReducer) {
    hook.helpers.loadHookHelper().then(function () {
      hook.debugFiber(container, options);
    });
  } else {
    hook.debugFiber(container, options);
  }
};